module.exports = __webpack_public_path__ + "img/20_59.67dd0dee.png";